<template>
  <mdb-container ref="mainContainer" class="main-container">
    <h1 class="h1-responsive mt-4 mb-3 text-center"><strong>Советы начинающему кайтеру</strong></h1>
    <section class="mb-3">
      <h2 class="h2-responsive mt-4 mb-3 text-center"><strong>Как выбрать первый кайт?</strong></h2>
      <mdb-row>
        <mdb-col md="12">
          <p>
            При выборе своего первого кайта, теряешься в многообразии информации . На самом деле для новичка выбор не такой уж и большой. Рассмотрим основные моменты, на которые следует обратить внимание при выборе первого кайта.
          </p>
          <h3 class="h3-responsive mt-4 mb-3 text-center"><strong>Тип кайта</strong></h3>
          <p class=" text-center">
              Если кратко, то кайты бывают двух типов: <strong>бескаркасные (парафойлы)</strong> и <strong>с надувным каркасом (надувастики)</strong>
          </p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="6" class="text-center">
          <figure class="figure">
            <img :src="foilImg" class="figure-img img-fluid z-depth-1"
                 alt="Парафоил (Фоил кайт, бескаркасный)">
            <figcaption class="figure-caption">Парафоил (Фоил кайт, бескаркасный)</figcaption>
          </figure>
        </mdb-col>
        <mdb-col md="6" class="text-center">
          <figure class="figure">
            <img :src="inflateImg" class="figure-img img-fluid z-depth-1"
                 alt="Кайт с надувным каркасом">
            <figcaption class="figure-caption">Кайт с надувным каркасом</figcaption>
          </figure>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <p class="text-center">Взять для начала надувной кайт - то что нужно - подойдет и для сноукайтинга и для кайтсерфига, держит форму, не боится ни снега, ни воды.</p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <h3 class="h3-responsive mt-4 mb-3 text-center"><strong>Производители кайтов</strong></h3>
          <p class="text-center">
            С типом определились, переходим к брендам. На просторах интернета встретил очень инересную аналогию на примере производителей авто:<br>
          </p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <h5 class="h5-responsive text-center my-3"><strong>Топ уровень</strong></h5>
          <p class="text-center">
            <b>BMW, Mercedes, Audi.</b> - в кайт мире это <strong>North (Германия), Cabrinha (США), Core (Германия), F-one (Франция)</strong>
          </p>
        </mdb-col>
      </mdb-row>
      <mdb-row class="my-2 brand-previews">
        <mdb-col md="3" class="text-center">
          <img :src="northImg">
        </mdb-col>
        <mdb-col md="3" class="text-center">
          <img :src="cabrinhaImg">
        </mdb-col>
        <mdb-col md="3" class="text-center">
          <img :src="coreImg">
        </mdb-col>
        <mdb-col md="3" class="text-center">
          <img :src="foneImg">
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <p class="text-center">Кайты этих производителей имеют отличные летные характеристики, проработанные системы безопасности, качественный материал и пошив кайтов. Если позволяет бюджет - это ваш выбор.</p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <h5 class="h5-responsive text-center my-3"><strong>Хорошие среднячки</strong></h5>
          <p class="text-center">
            <b>Ford, Toyota или Volkswagen</b> - в кайт мире это <strong>Slingshot (США), Nobile (Польша), Blade (Израиль), Naish (Гавайи), Griffin (Австралия).</strong><br>
          </p>
        </mdb-col>
      </mdb-row>
      <mdb-row class="my-2 brand-previews">
        <mdb-col md="1" class="text-center"></mdb-col>
        <mdb-col md="2" class="text-center">
          <img :src="slingshotImg">
        </mdb-col>
        <mdb-col md="2" class="text-center">
          <img :src="nobileImg">
        </mdb-col>
        <mdb-col md="2" class="text-center">
          <img :src="bladeImg">
        </mdb-col>
        <mdb-col md="2" class="text-center">
          <img :src="naishImg">
        </mdb-col>
        <mdb-col md="2" class="text-center">
          <img :src="griffinImg">
        </mdb-col>
        <mdb-col md="1" class="text-center"></mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <p class="text-center">Хорошие летные характеристики, но материалы более дешевые. В итоге мы получаем отличный кайт за более доступную цену. Если бюджет ограничен - это то, что нужно!</p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <h3 class="h3-responsive mt-4 mb-3 text-center"><strong>Форма кайта</strong></h3>
          <p class="text-center">
            Сегодня в мире кайтинга большое многообразие типов кайтов. Однако все их можно разделить на две группы:<br> <strong>универсальные (гибриды) </strong> и <strong>специализированные (боу, C-типы)</strong>
          </p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12" class="text-center">
          <img class="content-image-650" :src="typesImg">
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12" class="text-center">
          <p class="text-center">
            Главное их отличие - это форма арки. Форма арки влияет на летные характеристики, тяговые показатели кайта.
            Новичкам стоит присмотреться к гибридным кайтам, они более универсальны.
          </p>
          <p class="text-center">
            Начинающему кайтеру подойдут такие модели кайтов, как <strong>F-one Bandit, Cabrinha Switchblade, Core XR4, North Rebel, Slingshot Rally, Nobile T5</strong>. Эти кайты созданы для фрирайда, они отлично перезапускаются с воды, обладают прекрасной управляемостью по всей зоне ветрового окна и при необходимости способны полностью сбрасывать тягу.
          </p>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12" class="text-center">
          <h3 class="h3-responsive mt-4 mb-3 text-center"><strong>Размер кайта</strong></h3>
          <p>
            Размер кайта в основном зависит от двух факторов - скорость ветра и вес кайтера.
            Ульяновск и область не богата стабильными и ровными ветрами, скорость ветра редко поднимается больше 10 м/с.
            Поэтому можно смело разбить размер на 4-е категории:<br> <strong>Женщины и дети – 10м, Легкие райдеры – 11м, Крепкие ребята – 12м, Массивные кайтеры – 13м+.</strong>
          </p>
        </mdb-col>
      </mdb-row>
    </section>
    <section class="mb-3">
      <h2 class="h2-responsive mt-4 mb-3 text-center"><strong>Теоретическая база</strong></h2>
      <mdb-row>
        <mdb-col md="12">
          <p class="text-center">
            Для освоения базовых понятий и принципов кайтинга, предлагаю посмотреть цикл видеоматериалов.
            Несмотря на плохое качество картинки, видео очень качественные по содержанию и без лишней информации.
          </p>
          <div class="text-center">
            <iframe v-if="loadFrames" :width="frameWidth" :height="frameHeight" src="https://www.youtube.com/embed/Wk2LtnP00J0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol } from 'mdbvue'
import SpotFrame from '../SpotFrame'
import foilImg from '../../assets/content/foil.png'
import inflateImg from '../../assets/content/inflate.png'
import typesImg from '../../assets/content/types.png'
import bladeImg from '../../assets/content/brands/blade.jpg'
import cabrinhaImg from '../../assets/content/brands/cabrinha.jpg'
import coreImg from '../../assets/content/brands/core.jpg'
import foneImg from '../../assets/content/brands/fone.jpg'
import griffinImg from '../../assets/content/brands/griffin.jpg'
import naishImg from '../../assets/content/brands/naish.jpg'
import nobileImg from '../../assets/content/brands/nobile.jpg'
import northImg from '../../assets/content/brands/north.jpg'
import slingshotImg from '../../assets/content/brands/slingshot.jpg'

export default {
  name: 'BeginPage',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    SpotFrame
  },
  data: function () {
    return {
      foilImg,
      inflateImg,
      typesImg,
      bladeImg,
      cabrinhaImg,
      coreImg,
      foneImg,
      griffinImg,
      naishImg,
      nobileImg,
      northImg,
      slingshotImg,
      frameSrc: 'https://www.youtube.com/embed/Wk2LtnP00J0',
      frameWidth: 0,
      frameHeight: 0,
      loadFrames: false
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.loadFrames = true

      this.frameWidth = this.$refs.mainContainer.$el.clientWidth < 560 ? (this.$refs.mainContainer.$el.clientWidth - 30) : 560
      this.frameHeight = parseInt(this.frameWidth / 1.77)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/BeginPage.vue